import { render, staticRenderFns } from "./CBTScores.vue?vue&type=template&id=05d9d8a9&"
import script from "./CBTScores.vue?vue&type=script&lang=js&"
export * from "./CBTScores.vue?vue&type=script&lang=js&"
import style0 from "./CBTScores.vue?vue&type=style&index=0&soped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports